import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Switch, FormControlLabel } from '@mui/material';
import supabaseClient from '../../config';

const SubUsersManagement = ({ user }) => {
  const [subUsers, setSubUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ id: null, email: '', password: '', first_name: '', last_name: '', is_active: true });

  const fetchSubUsers = async () => {
    const { data, error } = await supabaseClient
      .from('invoice_sub_users')
      .select('*')
      .eq('tenant_id', user.id)
      .order('created_at', { ascending: false });
      
    if (!error && data) {
      setSubUsers(data);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      fetchSubUsers();
    }
  }, [user]);

  const handleOpen = (subUser = null) => {
    if (subUser) {
      setFormData({ ...subUser });
    } else {
      setFormData({ id: null, email: '', password: '', first_name: '', last_name: '', is_active: true });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    const payload = {
      tenant_id: user.id,
      email: formData.email,
      password: formData.password,
      first_name: formData.first_name,
      last_name: formData.last_name,
      is_active: formData.is_active
    };

    if (formData.id) {
      await supabaseClient.from('invoice_sub_users').update(payload).eq('id', formData.id);
    } else {
      await supabaseClient.from('invoice_sub_users').insert([payload]);
    }
    
    fetchSubUsers();
    handleClose();
  };

  if (user?.is_sub_user) {
    return <Typography color="error">No tienes permiso para ver esta sección.</Typography>;
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Gestión de Sub Usuarios
      </Typography>
      <Button variant="contained" color="primary" onClick={() => handleOpen()} sx={{ mb: 2 }}>
        Añadir Sub Usuario
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subUsers.map((su) => (
              <TableRow key={su.id}>
                <TableCell>{su.email}</TableCell>
                <TableCell>{su.first_name} {su.last_name}</TableCell>
                <TableCell>{su.is_active ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  <Button size="small" onClick={() => handleOpen(su)}>Editar</Button>
                </TableCell>
              </TableRow>
            ))}
            {subUsers.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">No hay sub usuarios creados</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{formData.id ? 'Editar Sub Usuario' : 'Nuevo Sub Usuario'}</DialogTitle>
        <DialogContent>
          <TextField sx={{ mt: 2 }} margin="dense" label="Email" fullWidth value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} />
          <TextField margin="dense" label="Contraseña" type="password" fullWidth value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} />
          <TextField margin="dense" label="Nombres" fullWidth value={formData.first_name} onChange={(e) => setFormData({...formData, first_name: e.target.value})} />
          <TextField margin="dense" label="Apellidos" fullWidth value={formData.last_name} onChange={(e) => setFormData({...formData, last_name: e.target.value})} />
          <FormControlLabel sx={{ mt: 1 }} control={<Switch checked={formData.is_active} onChange={(e) => setFormData({...formData, is_active: e.target.checked})} />} label="Activo" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SubUsersManagement;
